export const getInputHeight = ({ inputHeightProps, compLayout, isMobileView, }, formatCssValue, spx) => {
    const { inputHeightMobile, inputHeight } = inputHeightProps;
    const { height } = compLayout;
    const actualHeight = isMobileView
        ? inputHeightMobile || inputHeight || height
        : inputHeight || height;
    return formatCssValue
        ? formatCssValue(actualHeight, spx)
        : `${actualHeight}px`;
};
export const getLabelPadding = (labelPaddingProps, formatCssValue, spx) => {
    const { labelPadding, textAlignment, filesAlignment, alignment } = labelPaddingProps;
    const labelPaddingLimit = String(labelPadding).endsWith('spx') ? '20spx' : 20;
    const align = textAlignment || filesAlignment || alignment;
    switch (align) {
        case 'left':
            return formatCssValue
                ? formatCssValue(`0 ${labelPaddingLimit} 0 ${labelPadding}`, spx)
                : `0 ${labelPaddingLimit}px 0 ${labelPadding}px`;
        case 'right':
            return formatCssValue
                ? formatCssValue(`0 ${labelPadding} 0 ${labelPaddingLimit}`, spx)
                : `0 ${labelPadding}px 0 ${labelPaddingLimit}px`;
        default:
            return undefined;
    }
};
export const getRequiredIndicationDisplay = (styleProperties) => {
    const { txtlblrq } = styleProperties;
    return !txtlblrq || txtlblrq === 'transparent' ? 'none' : 'inline';
};
export const getTextPadding = ({ textAlignment, textPadding }, formatCssValue, spx) => {
    const textPaddingLimit = String(textPadding).endsWith('spx') ? '45spx' : 45;
    switch (textAlignment) {
        case 'left':
            return formatCssValue
                ? formatCssValue(`0 ${textPaddingLimit} 0 ${textPadding}`, spx)
                : `0 ${textPaddingLimit}px 0 ${textPadding}px`;
        case 'right':
            return formatCssValue
                ? formatCssValue(`0 ${textPadding} 0 ${textPaddingLimit}`, spx)
                : `0 ${textPadding}px 0 ${textPaddingLimit}px`;
        case 'center':
            return formatCssValue
                ? formatCssValue(`0 ${textPaddingLimit} 0 ${textPaddingLimit}`, spx)
                : `0 ${textPaddingLimit}px 0 ${textPaddingLimit}px`;
        default:
            return '';
    }
};
//# sourceMappingURL=inputUtils.js.map